import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetDefinitionName = urlConfig.GetDefinitionName;
const MetadataDefinitionConfiguartion =
  urlConfig.MetadataDefinitionConfiguartion;
const GetAvailableMetadataDefinitionConfiguartion =
  urlConfig.GetAvailableMetadatadefinition;
const MetadatadefinitionInsert = urlConfig.MetadatadefinitionInsert;

export const getMetadataDefinition = async (params: any) => {
  try {
    const response = await postCall(GetDefinitionName, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getEnabledMetadataDefinition = async (params: any) => {
  try {
    const response = await postCall(MetadataDefinitionConfiguartion, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getAvailableMetadataDefinition = async (params: any) => {
  try {
    const response = await postCall(
      GetAvailableMetadataDefinitionConfiguartion,
      params
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const metadataDefinitionInsert = async (params: any) => {
  try {
    const response = await postCall(MetadatadefinitionInsert, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
